import React from 'react';
import { StoryCard } from '../StoryCard';

class SandboxCard extends StoryCard {
	render() {
		return <div className="sandbox-card">{super.renderCard()}</div>;
	}
}

export default SandboxCard;
